export default __webpack_public_path__ + "static/media/logo.ffcf5261.jpg";